import { render } from "./TariffProviderComponent.vue?vue&type=template&id=39f128aa&scoped=true"
import script from "./TariffProviderComponent.vue?vue&type=script&lang=js"
export * from "./TariffProviderComponent.vue?vue&type=script&lang=js"

import "./TariffProviderComponent.vue?vue&type=style&index=0&id=39f128aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f128aa"]])

export default __exports__